import React, { PureComponent } from 'react';
import { withStoreDetail } from '../Common/Providers/WithStoreDetail';
import { HTMLTrans } from '../Common/Translations';

class HomepageSEO extends PureComponent {
  render() {
    const { store: { name = 'Photobook' } = {} } = this.props;
    return (
      <div className='container-fluid content-visibility-auto'>
        <div className="row bg-gray-lighten-4">
          <div className="col-lg-8 mx-auto seo-content my-7 pb-3">
            <h2 className="text-center ProximaNova-Regular mb-1 landing-h1"><HTMLTrans id="landing_page.seo_title">
              Make Your Own Personalised Photo Books with Photobook</HTMLTrans>
            </h2>
            <div className="text-center ProximaNova-Regular"><HTMLTrans id="landing_page.seo_description1" variables={{'name': name}}>
              <p>At {name}, we want to celebrate life with all your greatest memories through
              personalisation. We make personalisation easily accessible to everyone by providing
              the perfect online platform along with a wide selection of Photo Books and Photo Albums.
              With various photo book sizes, papers, covers and accessories available, our free
              readybooks are designed to inspire your creativity along with our easy-to-use online
              photo book maker. Whether it's to remember your travel holiday, wedding ceremony,
              Christmas or New Year, printing a custom photo book with us ensures your picture-perfect
              moments are preserved for many years down the road.</p></HTMLTrans></div>

            <h2 className="text-center ProximaNova-Regular mb-1 landing-h1"><HTMLTrans id="landing_page.seo_title2">
              Create Personalised Home Decor, Prints and More Gifts</HTMLTrans>
            </h2>
            <div className="text-center ProximaNova-Regular"><HTMLTrans id="landing_page.seo_description2" variables={{'name': name}}>
              <p>Besides photo books, {name} also offer the best personalisable prints such as canvas
              prints, cards, stationeries, calendars, prints and photo gifts. We believe your memories
              should be printed on more than just albums that you can share and admire wherever you
              are - like a tumbler for the on-the-go and a desk calendar for your office table. Don't
              forget to keep your home looking good with custom wall decor like metal prints and photo
              tiles, adding a contemporary style at the same time.</p>
              <p>Make your own gifts for any occasion including wedding, travel, baby milestone,
              birthday, graduation, special celebration such as Christmas and Valentine's Day.
              Curate your best photographs and create a custom gift today through the simple online
              designer that is programmed with useful tools for every personalisation need.</p>
              <p>No more worries about finding the perfect gifts because nothing is more unique than
              personalised gifts from the heart.</p>
              </HTMLTrans></div>
          </div>
        </div>
      </div>
    );
  }
}

export default withStoreDetail(HomepageSEO);
export const undecorated = HomepageSEO;



// WEBPACK FOOTER //
// ./src/LandingPage/Seo.js